/**
 * Format of parameters sent in an HTTP request or response.
 * Values match the backend ParameterFormatEnum.
 */
export enum ParameterFormatEnum {
    None = 0,
    QueryString = 1,
    Json = 2,
    Xml = 3
}

/**
 * Display labels for ParameterFormatEnum values.
 */
export const ParameterFormatLabels: Record<ParameterFormatEnum, string> = {
    [ParameterFormatEnum.None]: 'None',
    [ParameterFormatEnum.QueryString]: 'QueryString',
    [ParameterFormatEnum.Json]: 'Json',
    [ParameterFormatEnum.Xml]: 'Xml'
};

/**
 * Helper class for ParameterFormatEnum operations.
 */
export class ParameterFormatEnumHelpers {
    /**
     * Get all enum options as an array suitable for dropdowns.
     */
    static getOptions(): { value: number; label: string }[] {
        return Object.keys(ParameterFormatEnum)
            .filter(key => !isNaN(Number(key)))
            .map(key => ({
                value: Number(key),
                label: ParameterFormatLabels[Number(key) as ParameterFormatEnum]
            }));
    }

    /**
     * Get the display label for an enum value.
     */
    static getLabel(value: ParameterFormatEnum | number): string {
        return ParameterFormatLabels[value as ParameterFormatEnum] || 'Unknown';
    }
}
